import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule, MatButtonModule,MatToolbarModule,MatTableModule,
		 MatIconModule,MatSidenavModule,MatGridListModule,
		 MatCardModule,MatPaginatorModule,MatFormFieldModule,
		 MatInputModule,MatDialogModule,MatListModule,MatSelectModule,MatDatepickerModule,MatTabsModule,
     MatProgressSpinnerModule,MatProgressBarModule,MatMenuModule,MatSlideToggleModule,MatSnackBarModule,
     MatAutocompleteModule,MatTooltipModule,MatSortModule,MatChipsModule, MatExpansionModule, MatCheckboxModule, MatRadioModule, MatNativeDateModule, MatDividerModule } from '@angular/material';

@NgModule({
  imports: [MatRippleModule, MatButtonModule,MatToolbarModule,MatTableModule,
  			MatIconModule,MatSidenavModule,MatGridListModule,
  			MatCardModule,MatPaginatorModule,MatFormFieldModule,
  			MatInputModule,MatDialogModule,MatListModule,MatSelectModule,MatDatepickerModule,MatTabsModule,
        MatProgressSpinnerModule,MatProgressBarModule,MatMenuModule,MatSlideToggleModule,MatSnackBarModule,
        MatAutocompleteModule,MatTooltipModule,MatSortModule, MatChipsModule, MatExpansionModule, MatCheckboxModule, MatRadioModule, MatNativeDateModule, MatDividerModule],
  exports: [MatRippleModule, MatButtonModule,MatToolbarModule,MatTableModule,
  			MatIconModule,MatSidenavModule,MatGridListModule,
  			MatCardModule,MatPaginatorModule,MatFormFieldModule,
  			MatInputModule,MatDialogModule,MatListModule,MatSelectModule,MatDatepickerModule,MatTabsModule,
        MatProgressSpinnerModule,MatProgressBarModule,MatMenuModule,MatSlideToggleModule,MatSnackBarModule,
        MatAutocompleteModule,MatTooltipModule,MatSortModule, MatChipsModule, MatExpansionModule, MatCheckboxModule, MatRadioModule, MatNativeDateModule, MatDividerModule],
})
export class MaterialModule { }